import React, { useEffect, useState } from 'react'
import { Text } from '@mantine/core'

const ACTIVITY_END_DATE = new Date('2026-02-28T23:59:59')

const ActivityEndNotice: React.FC = () => {
  const [daysLeft, setDaysLeft] = useState<number>(0)

  useEffect(() => {
    const calculateDaysLeft = () => {
      const now = new Date()
      const diff = ACTIVITY_END_DATE.getTime() - now.getTime()
      const days = Math.max(0, Math.ceil(diff / (1000 * 60 * 60 * 24)))
      setDaysLeft(days)
    }

    calculateDaysLeft()
    const timer = setInterval(calculateDaysLeft, 60000)
    return () => clearInterval(timer)
  }, [])

  if (daysLeft <= 0) {
    return (
      <div
        style={{
          background: 'linear-gradient(135deg, #FF4757 0%, #FF6B81 100%)',
          borderRadius: 12,
          padding: '12px 16px',
          marginBottom: 12,
          boxShadow: '0 4px 12px rgba(255, 71, 87, 0.3)',
        }}
      >
        <Text
          style={{
            color: 'white',
            fontSize: 14,
            fontWeight: 600,
            textAlign: 'center',
            textShadow: '0 1px 2px rgba(0, 0, 0, 0.2)',
          }}
        >
          ⚠️ 抽奖活动已结束，感谢您的参与！
        </Text>
      </div>
    )
  }

  return (
    <div
      style={{
        background: 'linear-gradient(135deg, #FF9500 0%, #FF6B00 100%)',
        borderRadius: 12,
        padding: '12px 16px',
        marginBottom: 12,
        boxShadow: '0 4px 12px rgba(255, 149, 0, 0.3)',
        border: '1px solid rgba(255, 255, 255, 0.2)',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
        <Text
          style={{
            color: 'white',
            fontSize: 14,
            fontWeight: 600,
            textAlign: 'center',
            textShadow: '0 1px 2px rgba(0, 0, 0, 0.2)',
            lineHeight: 1.5,
          }}
        >
          ⏰ 抽奖活动将于2月底结束，距离截止还有
          <span
            style={{
              display: 'inline-block',
              background: 'rgba(255, 255, 255, 0.25)',
              padding: '2px 8px',
              borderRadius: 6,
              margin: '0 6px',
              fontWeight: 700,
              fontSize: 16,
            }}
          >
            {daysLeft}
          </span>
          天
        </Text>
      </div>
      <Text
        style={{
          color: 'rgba(255, 255, 255, 0.9)',
          fontSize: 12,
          textAlign: 'center',
          marginTop: 6,
        }}
      >
        积分过期将无法参与抽奖，请尽快使用！
      </Text>
    </div>
  )
}

export default ActivityEndNotice
